import { render, staticRenderFns } from "./rule3.vue?vue&type=template&id=3a40c6d9&scoped=true"
import script from "./rule3.vue?vue&type=script&lang=js"
export * from "./rule3.vue?vue&type=script&lang=js"
import style0 from "./rule3.vue?vue&type=style&index=0&id=3a40c6d9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a40c6d9",
  null
  
)

export default component.exports